
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ReceiptGrid extends Serenity.EntityGrid<ReceiptRow, any> {
        protected getColumnsKey() { return 'Retail.Receipt'; }
        protected getDialogType() { return ReceiptDialog; }
        protected getIdProperty() { return ReceiptRow.idProperty; }
        protected getInsertPermission() { return ReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptRow.localTextPrefix; }
        protected getService() { return ReceiptService.baseUrl; }


        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 

            var voucherNo = FormatHelper.GetVoucherNo(59);
            var userDefinition = Q.Authorization.userDefinition;

            this.editItem(<ReceiptRow>{
                VoucherNo: voucherNo,
                VoucherTypeId:59,
                TransDate: now.toDateString(),
                CreatedBy: userDefinition.UserId, 
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId,
                ExchangeRate: userDefinition.exchangerate,
                CurrencyId: userDefinition.CurrencyId,
                EnteredBy: userDefinition.Username,
                UserId: userDefinition.UserId
            });
        }
    }
}